import { Controller } from "@hotwired/stimulus"
import lottie from "lottie-web"

// Connects to data-controller="lottie"
export default class extends Controller {
  static values = {
    path: String,
    loop: { type: Boolean, default: true },
    autoplay: { type: Boolean, default: true },
    renderer: { type: String, default: "svg" }
  }

  connect() {
    this.animation = lottie.loadAnimation({
      container: this.element,
      renderer: this.rendererValue,
      loop: this.loopValue,
      autoplay: this.autoplayValue,
      path: this.pathValue
    })
  }

  disconnect() {
    if (this.animation) {
      this.animation.destroy()
    }
  }
}
